import { List, Map, OrderedMap } from 'immutable';

import { ColorLabelProviderAbstract } from './colorlabelprovider.service.abstract';
import { LegendItem } from '../../../../shared/legend/legend.item';
import { Node } from '../../../../shared/api/nodes';
import { isNullOrUndefined } from 'util';
import { Model } from '../../../../shared/api/models';
import { Subset } from '../../../../shared/api/subsets';
import { HumanResource } from '../../../../shared/api/humanresources';
import { Activity } from '../../../../shared/api/activities';
import { NodeData } from '../../../../shared/api/nodedata';
import { TreeNode } from '../../tree/tree.node';

export class ColorLabelProviderNodesType extends ColorLabelProviderAbstract {

  private params;
  private _colorLabelProvider;

  public constructor(params: any, private models: List<Model>, private subModels: List<Model>, private subSets: List<Subset>, private responsible: List<HumanResource>, private activities: List<Activity>, private nodeData: OrderedMap<string, NodeData>, private nodes: OrderedMap<string, TreeNode>, colorLabelProvider) {
    super();
    this.params = params;
    this._colorLabelProvider = colorLabelProvider;
  }

  public color(element: Node) {
    if (!isNullOrUndefined(this.params) && !isNullOrUndefined(this.params[element.nodeType])) {
      return this.getColor(this.params[element.nodeType], element);
    }
    return super.color();
  }

  public legend() {
    return List<LegendItem>(Map(this.params).map(provider => {
      switch (provider) {
        case 'models':
          return { provider: provider, legend: this._colorLabelProvider.models(this.models).legend(this.nodes) };
        case 'submodels':
          return { provider: provider, legend: this._colorLabelProvider.submodels(this.subModels).legend(this.nodes) };
        case 'subsets':
          return { provider: provider, legend: this._colorLabelProvider.subsets(this.subSets).legend(this.nodes) };
        case 'targetDate':
          return { provider: provider, legend: this._colorLabelProvider.targetDate().legend() };
        case 'status':
          return { provider: provider, legend: this._colorLabelProvider.status().legend() };
        case 'sidestep':
          return { provider: provider, legend: this._colorLabelProvider.sidestep().legend() };
        case 'responsible':
          return { provider: provider, legend: this._colorLabelProvider.responsible(this.responsible).legend(this.nodes) };
        case 'difference':
          return { provider: provider, legend: this._colorLabelProvider.difference().legend() };
        case 'todostatus':
          return { provider: provider, legend: this._colorLabelProvider.basic().legend() };
        case 'importance':
          return { provider: provider, legend: this._colorLabelProvider.importance().legend() };
        case 'risk':
          return { provider: provider, legend: this._colorLabelProvider.risk().legend() };
        case 'qstatus.q1':
          return { provider: provider, legend: this._colorLabelProvider.qstatus().legend('executive') };
        case 'qstatus.q2':
          return { provider: provider, legend: this._colorLabelProvider.qstatus().legend('program') };
        case 'qstatus.q3':
          return { provider: provider, legend: this._colorLabelProvider.qstatus().legend('functional') };
        case 'qstatus.q4':
          return { provider: provider, legend: this._colorLabelProvider.qstatus().legend('resource') };
        case 'relatedstatus':
          return this._colorLabelProvider.relatedstatus(this.nodeData).legend();
        default:
          return { provider: provider, legend: this._colorLabelProvider.basic().legend() };
      }
    }).toArray());
  }

  private getColor(provider: string, element: any) {
    switch (provider) {
      case 'models':
        return this._colorLabelProvider.models(this.models).color(element);
      case 'submodels':
        return this._colorLabelProvider.submodels(this.subModels).color(element);
      case 'subsets':
        return this._colorLabelProvider.subsets(this.subSets).color(element);
      case 'targetDate':
        return this._colorLabelProvider.targetDate().color(element);
      case 'status':
        return this._colorLabelProvider.status().color(element);
      case 'sidestep':
        return this._colorLabelProvider.sidestep().color(element);
      case 'responsible':
        return this._colorLabelProvider.responsible(this.responsible).color(element);
      case 'difference':
        return this._colorLabelProvider.difference().color(element);
      case 'todostatus':
        return this._colorLabelProvider.todostatus(this.activities).color(element);
      case 'importance':
        return this._colorLabelProvider.importance().color(element);
      case 'risk':
        return this._colorLabelProvider.risk().color(element);
      case 'qstatus.q1':
        return this._colorLabelProvider.qstatus().color(element, 'executive');
      case 'qstatus.q2':
        return this._colorLabelProvider.qstatus().color(element, 'program');
      case 'qstatus.q3':
        return this._colorLabelProvider.qstatus().color(element, 'functional');
      case 'qstatus.q4':
        return this._colorLabelProvider.qstatus().color(element, 'resource');
      case 'relatedstatus':
        return this._colorLabelProvider.relatedstatus(this.nodeData).color(element);
      default:
        return this._colorLabelProvider.basic().color();
    }
  }

}
